/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxmUserauthV1RealmAccessEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXM_USERAUTH_V1_REALM_ACCESS_EVENT_ENTITY_NAME = 'ixm.userauth.v1.RealmAccessEvent';
export const ixmUserauthV1RealmAccessEventEntity = new schema.Entity<IxmUserauthV1RealmAccessEvent>(IXM_USERAUTH_V1_REALM_ACCESS_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxmUserauthV1RealmAccessEvent) => `${entity.metadata?.eventId}` });

